<template>
  <Modal
    v-model="isOpen"
    title="キャリアカウンセリングのご案内"
    :show-title="true"
    :show-title-icon="true"
    title-icon-type="agent"
    :show-close="true"
    :close-on-backdrop="true"
    :close-on-esc="true"
    :auto-focus="false"
    body-padding="0"
    :max-width="640"
    @close="handleClose"
  >
    <div :class="$style.body">
      <div :class="$style.inner">
        <p :class="$style.message">ご転職活動のご状況はいかがでしょうか？</p>
        <div :class="$style.tightBlock">
          <p :class="$style.message">現時点ですぐの転職をお考えでないという方でも、</p>
          <p :class="$style.message">
            「まずは情報収集のみ」「市場感や市場価値を知りたい」「現状を整理しておきたい」
          </p>
          <p :class="$style.message">
            などありましたら、まずはカジュアルにお話ができればと存じます。
          </p>
        </div>
        <p :class="$style.subline">▼30秒で予約完了！今すぐ最短日程をご確認いただけます。</p>
      </div>
    </div>
    <template #footer>
      <div :class="$style.buttonWrapper">
        <a :href="EEASY_URL" target="_blank" rel="noopener noreferrer" class="text-decoration-none">
          <Button variant="primary" button-style="filled">
            <span :class="$style.paragraph">
              <b :class="$style.b2">日程調整する</b>
            </span>
          </Button>
        </a>
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import Button from '@/components/shared/button/Button.vue';
import { EEASY_URL } from '@/utils/constants';
import { computed } from 'vue';
import Modal from './Modal.vue';

const props = defineProps<{
  modelValue: boolean;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
  (e: 'close'): void;
}>();

const isOpen = computed({
  get: () => props.modelValue,
  set: (value: boolean) => {
    emit('update:modelValue', value);
  },
});

const handleClose = (): void => {
  isOpen.value = false;
};
</script>

<style module>
.body {
  width: 100%;
  position: relative;
  border-radius: 12px;
  background-color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-size: 14px;
  color: #000;
  font-family: Inter, sans-serif;
}
.inner {
  align-self: stretch;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  color: #000;
  letter-spacing: 0.55px;
  line-height: 20px;
  font-weight: 500;
  gap: 12px;
  text-align: center;
}
.tightBlock {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  text-align: center;
}
.message {
  margin: 0;
  text-align: center;
}
.subline {
  margin: 0;
  text-align: center;
}
.buttonWrapper {
  align-self: stretch;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.paragraph {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.b2 {
  position: relative;
  letter-spacing: 0.55px;
  line-height: 21px;
}
</style>
